import React, { useState } from 'react';
import { toast } from 'sonner';
import { ArrowRight, Lock, Mail } from 'lucide-react';
import { erpLogin } from '../../services/erpApi';
import { LOGO_URL } from './ui';
import { HERO_IMG } from './nav';

const ErpLogin = ({ onAuthed }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await erpLogin({ email, password });
      localStorage.setItem('erp_token', data.token);
      onAuthed(data.user);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="erp-root min-h-screen grid lg:grid-cols-[1.1fr_1fr]" data-testid="erp-login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden" style={{ background: 'var(--erp-navy)' }}>
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25 mix-blend-luminosity" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(120deg, rgba(11,26,74,.95) 30%, rgba(11,26,74,.55) 100%)' }} />
        <div className="relative inline-flex bg-white rounded-xl p-3 w-fit shadow-lg"><img src={LOGO_URL} alt="Namoh Toolings" className="h-20 object-contain" /></div>
        <div className="relative text-white erp-rise">
          <p className="text-xs tracking-[.3em] font-semibold text-blue-200/80 mb-4">ENTERPRISE RESOURCE PLANNING</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold leading-[1.05] tracking-tight">Precision today.<br />A stronger tomorrow.</h1>
          <p className="mt-6 text-blue-100/80 max-w-md text-base">One system for Trading, VCI Manufacturing, Import, Job Work and Finance — built for Namoh Toolings.</p>
          <div className="mt-10 flex gap-8 text-sm font-semibold text-blue-100/90">
            <span>WE LISTEN</span><span>WE INNOVATE</span><span>WE GROW TOGETHER</span>
          </div>
        </div>
        <p className="relative text-xs text-blue-200/50">© {new Date().getFullYear()} Namoh Toolings · ERP v1.0</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm erp-rise erp-d2" data-testid="erp-login-card">
          <img src={LOGO_URL} alt="Namoh Toolings" className="h-12 object-contain lg:hidden mb-8" />
          <h2 className="text-2xl font-extrabold tracking-tight">Sign in to Namoh ERP</h2>
          <p className="text-sm mt-1 mb-8" style={{ color: 'var(--erp-muted)' }}>Use your ERP credentials issued by the administrator.</p>
          <div className="space-y-4">
            <div>
              <label className="block text-[12.5px] font-semibold mb-1.5" style={{ color: '#3b4664' }}>Work email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2" style={{ color: 'var(--erp-muted)' }} />
                <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="erp-input erp-input-icon erp-input-lg" placeholder="you@namohtoolings.in" data-testid="erp-login-email" />
              </div>
            </div>
            <div>
              <label className="block text-[12.5px] font-semibold mb-1.5" style={{ color: '#3b4664' }}>Password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2" style={{ color: 'var(--erp-muted)' }} />
                <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="erp-input erp-input-icon erp-input-lg" placeholder="••••••••" data-testid="erp-login-password" />
              </div>
            </div>
          </div>
          <button type="submit" disabled={busy} className="erp-btn erp-btn-navy w-full h-12 mt-6 text-[15px]" data-testid="erp-login-submit">
            {busy ? 'Signing in…' : <>Sign in <ArrowRight size={16} /></>}
          </button>
          <p className="text-xs text-center mt-6" style={{ color: 'var(--erp-muted)' }}>Access is role-based. Contact your administrator for permissions.</p>
        </form>
      </div>
    </div>
  );
};

export default ErpLogin;
